(function () {
  'use strict';

  var keyboardSupport = function (container, hasTabs) {
    var tablist = container.querySelectorAll('[role="tablist"]')[0];
    var tabs;
    var panels;

    var generateArrays = function () {
      panels = container.querySelectorAll('[role="tabpanel"]');
      tabs = container.querySelectorAll('[role="tab"]');
    };

    generateArrays();

    var keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      delete: 46,
      enter: 13,
      space: 32
    };

    var direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1
    };

    var deactivateTabs = function () {
      for (var t = 0; t < tabs.length; t++) {
        tabs[t].setAttribute('tabindex', '-1');
        tabs[t].setAttribute('aria-selected', 'false');
      }
    };

    var activateTab = function (tab, setFocus) {
      setFocus = setFocus || true;
      deactivateTabs();
      tab.removeAttribute('tabindex');
      tab.setAttribute('aria-selected', 'true');
      if (setFocus) {
        tab.focus();
      }
    };

    // var triggerTabClick = function (e) {
    //   var clickedId = e.target.getAttribute('id');
    //   if (clickedId) {
    //     var clickedTab = container.querySelector('[aria-controls="' + clickedId + '"]');
    //     clickedTab.click();
    //     document.getElementById(clickedId).scrollIntoView({
    //       behavior: 'smooth'
    //     });
    //   }
    // };

      const triggerTabClick = function (e) {
        const clickedId = e.target.getAttribute('id');
        if (clickedId) {
          const clickedTab = container.querySelector('[aria-controls="' + clickedId + '"]');
          clickedTab.click();
          
          const stickyHeaderHeight = document.querySelector('.header').offsetHeight; // replace '.header' if your class is different
          const targetPosition = document.getElementById(clickedId).offsetTop - stickyHeaderHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      };

    var accordionClickEventListener = function (event) {
      triggerTabClick(event);
    };

    var clickEventListener = function (event) {
      var tab = event.target;
      activateTab(tab, false);
    };

    var focusFirstTab = function () {
      var target = hasTabs ? tabs : panels;
      target[0].focus();
    };

    var focusLastTab = function () {
      var target = hasTabs ? tabs : panels;
      target[target.length - 1].focus();
    };

    var switchTabOnArrowPress = function (event) {
      var pressed = event.keyCode;

      if (direction[pressed]) {
        var target = event.target;
        var targetElems = hasTabs ? tabs : panels;
        if (target.index !== undefined) {
          if (targetElems[target.index + direction[pressed]]) {
            targetElems[target.index + direction[pressed]].focus();
          } else if (pressed === keys.left || pressed === keys.up) {
            focusLastTab();
          } else if (pressed === keys.right || pressed === keys.down) {
            focusFirstTab();
          }
        }
      }
    };

    var determineOrientation = function (event) {
      var key = event.keyCode;
      var vertical = tablist ? tablist.getAttribute('aria-orientation') === 'vertical' : null;
      var proceed = false;

      if (vertical || !hasTabs) {
        if (key === keys.up || key === keys.down) {
          event.preventDefault();
          proceed = true;
        }
      } else {
        if (key === keys.left || key === keys.right) {
          proceed = true;
        }
      }

      if (proceed) {
        switchTabOnArrowPress(event);
      }
    };

    var keydownEventListener = function (event) {
      var key = event.keyCode;
      switch (key) {
        case keys.end:
          event.preventDefault();
          focusLastTab();
          break;
        case keys.home:
          event.preventDefault();
          focusFirstTab();
          break;
        case keys.up:
        case keys.down:
          determineOrientation(event);
          break;
      }
    };

    var keyupEventListener = function (event) {
      var key = event.keyCode;
      switch (key) {
        case keys.left:
        case keys.right:
          determineOrientation(event);
          break;
        case keys.enter:
        case keys.space:
          if (hasTabs) {
            activateTab(event.target);
          } else {
            triggerTabClick(event);
          }
          break;
      }
    };

    var addListeners = function (index) {
      var target = hasTabs ? tabs[index] : panels[index];
      tabs[index].addEventListener('click', clickEventListener);
      if (target) {
        if (!hasTabs) {
          target.addEventListener('click', accordionClickEventListener);
        }
        target.addEventListener('keydown', keydownEventListener);
        target.addEventListener('keyup', keyupEventListener);
        target.index = index;
      }
    };

    for (var i = 0; i < tabs.length; ++i) {
      addListeners(i);
    }

    if (!hasTabs) {
      for (var j = 0; j < panels.length; j++) {
        panels[j].onclick = function (e) {
          triggerTabClick(e);
        };
      }
    }
  };

  var toggleClass = function (otherElems, thisELem, className) {
    className = className || 'is-active';
    for (var i = 0; i < otherElems.length; i++) {
      otherElems[i].classList.remove(className);
    }
    thisELem.classList.add(className);
  };

  var toggleVerticalTabs = function (tabContainer, tabs, items, item) {
    item.onclick = function (e) {
      var currId = item.getAttribute('id');
      var tab = tabContainer.querySelector('.ootb-tabcordion--tabs [aria-controls="' + currId + '"]');
      toggleClass(tabs, tab);
      toggleClass(items, item);
    };
  };

  var toggleTabs = function (tabContainer) {
    var tabs = tabContainer.querySelectorAll('.ootb-tabcordion--tabs .tab');
    var items = tabContainer.querySelectorAll('.ootb-tabcordion--entry');
    for (var i = 0; i < tabs.length; i++) {
      (function(tab) {
        tab.onclick = function () {
          var target = tab.getAttribute('aria-controls');
          var content = document.getElementById(target);
          toggleClass(tabs, tab);
          toggleClass(items, content);
        };
      })(tabs[i]);
    }
    for (var j = 0; j < items.length; j++) {
      toggleVerticalTabs(tabContainer, tabs, items, items[j]);
    }
  };

  var hasTabs = function (container) {
    return container.classList.contains('has-tabs');
  };

  var modeSwitcher = function (tabContainer, containerWidth) {
    var tabs = tabContainer.querySelectorAll('.tab');
    var container = tabs[0].closest('.ootb-tabcordion');
    var totalW = 0;
    for (var i = 0; i < tabs.length; i++) {
      totalW += tabs[i].offsetWidth;
    }
    if (totalW >= containerWidth) {
      container.classList.remove('has-tabs');
    } else {
      container.classList.add('has-tabs');
    }
    keyboardSupport(tabContainer, hasTabs(container));
  };

  var resizeObserver = new ResizeObserver(function(entries) {
    for (var i = 0; i < entries.length; i++) {
      modeSwitcher(entries[i].target, entries[i].contentRect.width);
    }
  });

  var tabContainers = document.querySelectorAll('.ootb-tabcordion');
  for (var i = 0; i < tabContainers.length; i++) {
    var tabList = tabContainers[i].querySelector('.ootb-tabcordion--tabs');
    resizeObserver.observe(tabList);
    toggleTabs(tabContainers[i]);
    keyboardSupport(tabContainers[i], hasTabs(tabContainers[i]));
  }

})();



// (function () {
//   'use strict';

//   var keyboardSupport = function (container, hasTabs) {
//     // Your existing code remains unchanged
//   };

//   var toggleClass = function (otherElems, thisELem, className) {
//     className = className || 'is-active';
//     for (var i = 0; i < otherElems.length; i++) {
//       otherElems[i].classList.remove(className);
//     }
//     thisELem.classList.add(className);
//   };

//   var toggleVerticalTabs = function (tabContainer, tabs, items, item) {
//     item.onclick = function (e) {
//       var currId = item.getAttribute('id');
//       var tab = tabContainer.querySelector('.ootb-tabcordion--tabs [aria-controls="' + currId + '"]');
//       toggleClass(tabs, tab);
//       toggleClass(items, item);
//     };
//   };

//   var toggleTabs = function (tabContainer) {
//     var tabs = tabContainer.querySelectorAll('.ootb-tabcordion--tabs .tab');
//     var items = tabContainer.querySelectorAll('.ootb-tabcordion--entry');

//     for (var i = 0; i < tabs.length; i++) {
//       (function(tab) {
//         tab.onclick = function (e) {
//           e.preventDefault(); // Prevent default behavior to stop scrolling
//           var target = tab.getAttribute('aria-controls');
//           var content = document.getElementById(target);
//           toggleClass(tabs, tab);
//           toggleClass(items, content);
//           content.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Smooth scroll to the section title
//         };
//       })(tabs[i]);
//     }
//     for (var j = 0; j < items.length; j++) {
//       toggleVerticalTabs(tabContainer, tabs, items, items[j]);
//     }
//   };

//   var hasTabs = function (container) {
//     return container.classList.contains('has-tabs');
//   };

//   var modeSwitcher = function (tabContainer, containerWidth) {
//    var tabs = tabContainer.querySelectorAll('.tab');
//     var container = tabs[0].closest('.ootb-tabcordion');
//     var totalW = 0;
//     for (var i = 0; i < tabs.length; i++) {
//       totalW += tabs[i].offsetWidth;
//     }
//     if (totalW >= containerWidth) {
//       container.classList.remove('has-tabs');
//     } else {
//       container.classList.add('has-tabs');
//     }
//     keyboardSupport(tabContainer, hasTabs(container));
//   };

//   var resizeObserver = new ResizeObserver(function(entries) {
//       for (var i = 0; i < entries.length; i++) {
//       modeSwitcher(entries[i].target, entries[i].contentRect.width);
//     }
//   });

//   var tabContainers = document.querySelectorAll('.ootb-tabcordion');
//   for (var i = 0; i < tabContainers.length; i++) {
//     var tabList = tabContainers[i].querySelector('.ootb-tabcordion--tabs');
//     resizeObserver.observe(tabList);
//     toggleTabs(tabContainers[i]);
//     keyboardSupport(tabContainers[i], hasTabs(tabContainers[i]));
//   }

// })();

